import { type PropsWithChildren, useCallback } from "react";
import { useDispatch } from "react-redux";
import type { ChatPropertiesType } from "@b2bportal/chat-api";
import { toggleChatWindow } from "@b2bportal/core-self-serve";
import type { ChatTransfer } from "@b2bportal/ivr-api";

import { type IChatSupportContext, ChatSupportContext } from "../../contexts";

export const AiAssistChatSupportProvider = ({
  children,
}: PropsWithChildren) => {
  const dispatch = useDispatch();

  const openChatWindow = useCallback(() => {
    // TODO - also check kill-switch to see if AI Service is down. If so, fallback to Kustomer
    dispatch(toggleChatWindow());
  }, [dispatch]);

  const openGeneralSupportChat = useCallback(async () => {
    // TODO - also check kill-switch to see if AI Service is down. If so, fallback to Kustomer
    dispatch(toggleChatWindow());
  }, [dispatch]);

  const openProductSpecificSupportChat = useCallback(
    async (
      _productId: string,
      _productType: ChatPropertiesType,
      _requestType: string,
      _chatTransfer?: ChatTransfer // Unused currently
    ) => {
      // TODO - also check kill-switch to see if AI Service is down. If so, fallback to Kustomer
      dispatch(toggleChatWindow());
    },
    [dispatch]
  );

  const supportContext: IChatSupportContext = {
    openChatWindow,
    generalSupportChat: openGeneralSupportChat,
    productSupportChat: openProductSpecificSupportChat,
  };

  return (
    <ChatSupportContext.Provider value={supportContext}>
      {children}
    </ChatSupportContext.Provider>
  );
};
